<template>
    <div class="form_group with_edit_btn">
        <label class="form_text_label">
            <span class="editable_text">{{localData.label}}</span>
            <span class="star">*</span>
        </label>
        <input type="text" name="" id="" class="control-input" :placeholder="localData.placeholder" :value="localData.value">
    </div>
</template>

<script>
export default {
    name: 'FormTextInput',
    props: ["index", "formElementData", "step"],
    data: function(){
        return {
            localData: {
                label: '',
                value: '',
            },
        }
    },
    methods: {
    },
    created() {
        this.localData = JSON.parse(JSON.stringify(this.formElementData));
    }
}
</script>